
export default {
    namespaced:true,
    state: {
       /**当前操作课程详情 */
       courseDetailData:{
        baseInfo:{},
        chapter:{},
        teachTeam:{},
        TeachUnit:{},
        setup:{},
        detail:{}
       },
       /**课程创建中的所属分类 */
       classifyCode:'',
       operation:'',
       /**课程学习预览数据 */
       studyCoursePreview:{},
       /**当前学习的单元Id */
       currentUnitId:'',
       /**当前学习主体资源id */
       resourceId:'',
       /**用户操作统计相关信息 */
       operationStatisticsInfo:{},
       /**当前课程id */
       currentCourseId:'',
       /**创建课程的tab切换控制 */
       activeName:'baseInfo',
       /**启用模型id */
       currentModelId:'ac00d104-571f-4f3a-b4e2-68cf56b4b24b'
    },
    mutations: {
      /**切换数字人模型id */
      changeModel(state,data){
        state.currentModelId=data;
      },
      /**切换tab */
      changeActiveName(state,value){
        state.activeName=value;
      },
      /**修改课程所属分类 */
      changeClassifyCode(state,data){
        state.classifyCode=data;
      },
      /**用户操作统计相关信息 */
      changeOperationStatisticsInfo(state,data){
        state.operationStatisticsInfo=data;
      },
      /**修改课程详情 */
      changeCourseDetail(state,data){
        state.courseDetailData[data.label]=data.value;
      },
      /**修改课程学习预览数据*/
      changeStudyCoursePreview(state,data){
        state.studyCoursePreview=data;
      },
      /**修改当前学习的单元Id */
      changecurrentUnitId(state,data){
        state.currentUnitId=data;
      },
      changeOperation(state,data){
        state.operation=data;
      },
      /**修改课程Id */
      changeId(state,value){
        state.currentCourseId=value;
        // localStorage.setItem('courseId',value);
      }
    },
    actions: {
       
    }
};